
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1sccy"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1sccy", function(module, exports) {

let $10f1def10df85b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10f1def10df85b37$var$load("h3ABO"),
    $10f1def10df85b37$var$load("2fH0a"),
    $10f1def10df85b37$var$load("OkWBV"),
    $10f1def10df85b37$var$load("4jlMu"),
    $10f1def10df85b37$var$load("2YffH"),
    $10f1def10df85b37$var$load("2VmDq"),
    $10f1def10df85b37$var$load("g7ggm"),
    $10f1def10df85b37$var$load("6mHrv"),
    $10f1def10df85b37$var$load("awWN9"),
    $10f1def10df85b37$var$load("9CYct"),
    $10f1def10df85b37$var$load("dJdZe"),
    $10f1def10df85b37$var$load("lgOou"),
    $10f1def10df85b37$var$load("hZtKG"),
    $10f1def10df85b37$var$load("dkqvW"),
    $10f1def10df85b37$var$load("lVO3w"),
    $10f1def10df85b37$var$load("hyzoX"),
    $10f1def10df85b37$var$load("h9Ed7"),
    $10f1def10df85b37$var$load("eBRUf"),
    $10f1def10df85b37$var$load("kbRvk"),
    $10f1def10df85b37$var$load("tKhaz"),
    $10f1def10df85b37$var$load("9Vh0G"),
    $10f1def10df85b37$var$load("hBIgN"),
    $10f1def10df85b37$var$load("cD6Zr"),
    $10f1def10df85b37$var$load("k3jER"),
    $10f1def10df85b37$var$load("9wzNh"),
    $10f1def10df85b37$var$load("8YSo7"),
    $10f1def10df85b37$var$load("9ldRJ"),
    $10f1def10df85b37$var$load("50ame"),
    $10f1def10df85b37$var$load("e7ZUf"),
    $10f1def10df85b37$var$load("gL8bn"),
    $10f1def10df85b37$var$load("1MlIV"),
    $10f1def10df85b37$var$load("6iz6l"),
    $10f1def10df85b37$var$load("4SCW2"),
    $10f1def10df85b37$var$load("drp1W"),
    $10f1def10df85b37$var$load("gb2Pz"),
    $10f1def10df85b37$var$load("hv4mn"),
    $10f1def10df85b37$var$load("Wowvf"),
    $10f1def10df85b37$var$load("dek7I"),
    $10f1def10df85b37$var$load("dYtBN"),
    $10f1def10df85b37$var$load("kNV5Y"),
    $10f1def10df85b37$var$load("6wr18"),
    $10f1def10df85b37$var$load("kjZZD"),
    $10f1def10df85b37$var$load("7cDV0"),
    $10f1def10df85b37$var$load("ijD5W"),
    $10f1def10df85b37$var$load("3JSgG"),
    $10f1def10df85b37$var$load("37ldp"),
    $10f1def10df85b37$var$load("ffEVr"),
    $10f1def10df85b37$var$load("9AXkC"),
    $10f1def10df85b37$var$load("28arV"),
    $10f1def10df85b37$var$load("hhss7"),
    $10f1def10df85b37$var$load("jYUNl"),
    $10f1def10df85b37$var$load("foy8I"),
    $10f1def10df85b37$var$load("f1Pmi"),
    $10f1def10df85b37$var$load("dP7ao"),
    $10f1def10df85b37$var$load("hogcU"),
    $10f1def10df85b37$var$load("5vfHd"),
    $10f1def10df85b37$var$load("2Stk7"),
    $10f1def10df85b37$var$load("7EorR"),
    $10f1def10df85b37$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.765ff153.js.map
